<!-- Map picker modal -->
<div class="map-modal-overlay" *ngIf="showMapModal">
  <div class="map-modal">
    <div class="map-search-bar">
      <input
        type="text"
        class="map-search-input"
        [(ngModel)]="mapSearchQuery"
        name="mapSearch"
        placeholder="Search"
        (keyup.enter)="searchMapLocation()"
      />
      <button type="button" class="map-search-btn" (click)="searchMapLocation()">Search</button>
      <button type="button" class="map-close-btn" (click)="closeMap()">&#10005;</button>
    </div>

    <div id="map-picker" class="map-container"></div>

    <button type="button" class="map-confirm-btn" (click)="confirmLocation()">Confirm</button>
  </div>
</div>

<div class="register-overlay">
  <!-- Form only when popup is NOT showing -->
  <div class="register-card" *ngIf="!showSetupScreen">
    <h2 class="card-title">Get Started</h2>
    <p class="card-subtitle">Free instant access. No credit card required.</p>

    <div class="apps-bar">
      <span class="apps-selected-pill">
        <svg class="pill-check" viewBox="0 0 16 16" fill="none" stroke="#14b8a6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3,8 6.5,11.5 13,5"/>
        </svg>
        {{ selectedApps.length }} {{ selectedApps.length === 1 ? 'app' : 'apps' }}
      </span>

      <button type="button" class="change-apps-btn" (click)="goBack.emit()">
        Change apps selection
      </button>
    </div>

    <form (ngSubmit)="onSubmit()" #regForm="ngForm">
      <!-- ================= CORE ================= -->
      <div class="field">
        <label class="field-label">Company Name <span class="req">*</span></label>
        <input
          class="field-input"
          type="text"
          [(ngModel)]="companyName"
          name="companyName"
          placeholder="Enter company name"
          (ngModelChange)="syncBranch()"
        />
        <span class="subdomain-preview">{{ subdomain }}.orderyaa.com</span>
      </div>

      <div class="field-row">
        <div class="field">
          <label class="field-label">Full Name <span class="req">*</span></label>
          <input
            class="field-input"
            type="text"
            [(ngModel)]="fullName"
            name="fullName"
            placeholder="Enter your name"
            (ngModelChange)="syncBranch()"
          />
        </div>

        <div class="field">
          <label class="field-label">Email <span class="req">*</span></label>
          <input
            class="field-input"
            type="email"
            [(ngModel)]="email"
            name="email"
            placeholder="Enter email"
            (ngModelChange)="syncBranch()"
          />
        </div>
      </div>

      <!-- ================= PASSWORD (eye icon) ================= -->
      <div class="field-row">
        <!-- Password -->
        <div class="field">
          <label class="field-label">Password <span class="req">*</span></label>

          <div class="password-wrap">
            <input
              class="field-input"
              [type]="showPassword ? 'text' : 'password'"
              [(ngModel)]="password"
              name="password"
              placeholder="Enter password"
            />

            <button
              type="button"
              class="eye-btn"
              tabindex="-1"
              (click)="showPassword = !showPassword"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
            >
              <!-- eye open -->
              <svg *ngIf="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <!-- eye off -->
              <svg *ngIf="showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.8 21.8 0 0 1 5.06-6.94"></path>
                <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a21.8 21.8 0 0 1-3.17 4.55"></path>
                <path d="M1 1l22 22"></path>
              </svg>
            </button>
          </div>
        </div>

        <!-- Confirm Password -->
        <div class="field">
          <label class="field-label">Confirm Password <span class="req">*</span></label>

          <div class="password-wrap">
            <input
              class="field-input"
              [type]="showConfirmPassword ? 'text' : 'password'"
              [(ngModel)]="confirmPassword"
              name="confirmPassword"
              placeholder="Confirm password"
            />

            <button
              type="button"
              class="eye-btn"
              tabindex="-1"
              (click)="showConfirmPassword = !showConfirmPassword"
              [attr.aria-label]="showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'"
            >
              <!-- eye open -->
              <svg *ngIf="!showConfirmPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <!-- eye off -->
              <svg *ngIf="showConfirmPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.8 21.8 0 0 1 5.06-6.94"></path>
                <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a21.8 21.8 0 0 1-3.17 4.55"></path>
                <path d="M1 1l22 22"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div class="field-row">
        <div class="field">
          <label class="field-label">Country <span class="req">*</span></label>
          <div class="country-dropdown-wrap">

            <!-- Trigger -->
            <div class="country-trigger"
                 [class.input-error]="formSubmitted && !address"
                 [class.country-trigger-open]="showCountryDrop"
                 tabindex="0"
                 (click)="openCountryDrop()"
                 (keydown)="onCountryTriggerKey($event)">
              <img *ngIf="selectedCountryCode" class="flag-img"
                   [src]="'https://flagcdn.com/w20/' + selectedCountryCode + '.png'"
                   [alt]="selectedCountryCode" />
              <span class="country-trigger-text" [class.country-placeholder]="!address">
                {{ address || (countriesLoading ? 'Loading...' : 'Select country') }}
              </span>
              <svg class="country-chevron" [class.rotated]="showCountryDrop" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M2 4l4 4 4-4" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>

            <!-- Panel -->
            <div class="country-drop-panel" *ngIf="showCountryDrop">
              <div class="country-search-wrap">
                <input
                  class="country-search-input"
                  type="text"
                  [(ngModel)]="countrySearch"
                  name="countrySearch"
                  placeholder="Search country..."
                  (input)="countryFocusIndex = 0"
                  (keydown)="onCountryKeydown($event)"
                  (blur)="onCountryBlur()"
                  autocomplete="off"
                />
              </div>
              <div class="country-options-list" tabindex="-1">
                <div
                  class="country-option"
                  [class.country-option-focused]="countryFocusIndex === i"
                  *ngFor="let c of filteredCountries; let i = index"
                  (mousedown)="selectCountry(c)"
                  [attr.data-idx]="i">
                  <img class="flag-img" [src]="'https://flagcdn.com/w20/' + c.code.toLowerCase() + '.png'" [alt]="c.code" />
                  {{ c.name }}
                </div>
                <div class="country-no-result" *ngIf="filteredCountries.length === 0">No results</div>
              </div>
            </div>

          </div>
          <span class="field-error-msg" *ngIf="formSubmitted && !address">
            Country is required.
          </span>
        </div>

        <div class="field">
          <label class="field-label">Phone number <span class="req">*</span></label>
          <div class="phone-wrap">
            <span class="phone-prefix" *ngIf="selectedCountryCode">
              <img class="flag-img" [src]="'https://flagcdn.com/w20/' + selectedCountryCode + '.png'" [alt]="selectedCountryCode" />
              {{ phoneCode }}
            </span>
            <input
              class="field-input phone-input"
              type="tel"
              [(ngModel)]="phone"
              name="phone"
              placeholder="Enter phone number"
              (ngModelChange)="syncBranch()"
            />
          </div>
        </div>
      </div>

      <div class="field-row">
        <div class="field">
          <label class="field-label">Currency <span class="req">*</span></label>
          <select
            class="field-input field-select"
            [(ngModel)]="currency"
            name="currency"
            [disabled]="currenciesLoading"
          >
            <option value="">{{ currenciesLoading ? 'Loading...' : 'Select currency' }}</option>
            <option *ngFor="let c of currencies" [value]="c.code">
              {{ c.code }} — {{ c.name }}
            </option>
          </select>
        </div>

        <div class="field">
          <label class="field-label">City</label>

          <!-- Dropdown: no country selected, loading, or has cities -->
          <select *ngIf="!address || citiesLoading || cities.length > 0"
            class="field-input field-select"
            [(ngModel)]="city"
            name="city"
            (ngModelChange)="onCityChange($event)"
            [disabled]="citiesLoading"
          >
            <option value="">
              {{ !address ? 'Select country first' : citiesLoading ? 'Loading cities...' : 'Select city' }}
            </option>
            <option *ngFor="let c of cities" [value]="c.name">{{ c.name }}</option>
          </select>

          <!-- Text input: country selected but no cities in DB -->
          <input *ngIf="address && !citiesLoading && cities.length === 0"
            class="field-input"
            type="text"
            [(ngModel)]="city"
            name="city"
            placeholder="Enter city name"
          />
        </div>
      </div>

      <!-- ================= ADVANCE ================= -->
      <div class="section-toggle-row">
        <button type="button" class="toggle-link" tabindex="-1" (click)="advanceExpanded = !advanceExpanded">
          Advance
          <span class="toggle-arrow" [class.rotated]="advanceExpanded">&#9660;</span>
        </button>
      </div>

      <div class="collapsible-section" *ngIf="advanceExpanded">

        <div style="display:flex; justify-content:flex-end; margin-bottom:8px;">
          <button type="button" class="pick-location-btn" (click)="openMapPicker('company')">
            Pick Location
            <svg width="14" height="14" viewBox="0 0 24 24" fill="#009ebf">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
          </button>
        </div>

        <div class="field-row">
          <div class="field">
            <label class="field-label">Longitude</label>
            <input class="field-input" type="text" [(ngModel)]="longitude" name="longitude" placeholder="Longitude" />
          </div>
          <div class="field">
            <label class="field-label">Latitude</label>
            <input class="field-input" type="text" [(ngModel)]="latitude" name="latitude" placeholder="Latitude" />
          </div>
        </div>

        <div class="field-row">
          <div class="field">
            <label class="field-label">Gender</label>
            <select class="field-input field-select" [(ngModel)]="gender" name="gender">
              <option value="">Select gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div class="field">
            <label class="field-label">Date of Birth</label>
            <input class="field-input" type="date" [(ngModel)]="dateOfBirth" name="dateOfBirth" />
          </div>
        </div>

        <div class="field-row">
          <div class="field">
            <label class="field-label">Radius</label>
            <input class="field-input" type="text" [(ngModel)]="radius" name="radius" placeholder="Enter allowed radius" />
          </div>
        </div>

        <div class="field">
          <label class="field-label">Company logo</label>
          <label class="upload-area">
            <img *ngIf="companyLogoPreview" [src]="companyLogoPreview" class="logo-preview" alt="logo" />
            <ng-container *ngIf="!companyLogoPreview">
              <div class="upload-icon-box">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="white">
                  <path
                    d="M19.35 10.04C18.67 6.59 15.64 4 12 4c-2.89 0-5.4 1.64-6.65 4.04C2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
                  />
                </svg>
              </div>
              <span class="upload-text">Upload logo</span>
            </ng-container>

            <input type="file" accept="image/*" style="display:none" (change)="onLogoUpload($event, 'company')" />
          </label>
        </div>
      </div>

      <!-- ================= BRANCHES + BUSINESS UNITS ================= -->
      <div class="branches-wrap">
        <div class="section-divider">
          <button type="button" class="section-toggle-btn" tabindex="-1" (click)="branchesExpanded = !branchesExpanded">
            <span>Branches and business units</span>
            <span class="toggle-arrow" [class.rotated]="branchesExpanded">&#9660;</span>
          </button>
        </div>

        <div class="collapsible-section" *ngIf="branchesExpanded">
          <div class="add-branch-row">
            <button type="button" class="add-branch-btn" (click)="addBranch()">
              <span class="plus">+</span> Add new branch
            </button>
          </div>

          <div class="branch-card" *ngFor="let b of branches; let bi = index">
            <!-- Branch header -->
            <div class="branch-card-header" (click)="toggleBranch(b.id)">
              <div class="branch-title">{{ b.branchName || 'Main branch' }}</div>

              <div class="branch-header-actions">
                <button
                  type="button"
                  class="delete-branch-btn"
                  title="Delete branch"
                  (click)="removeBranch(b.id); $event.stopPropagation()"
                  *ngIf="branches.length > 1"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2">
                    <path d="M3 6h18"></path>
                    <path d="M8 6V4h8v2"></path>
                    <path d="M6 6l1 14h10l1-14"></path>
                  </svg>
                </button>

                <span class="toggle-arrow" [class.rotated]="b.expanded">&#9660;</span>
              </div>
            </div>

            <!-- Branch body -->
            <div *ngIf="b.expanded">
              <div class="field-row">
                <div class="field">
                  <label class="field-label">Branch Name <span class="req">*</span></label>
                  <input class="field-input" type="text" [(ngModel)]="b.branchName" name="branchName{{b.id}}" placeholder="Main Branch" />
                </div>
                <div class="field">
                  <label class="field-label">Branch Code <span class="req">*</span></label>
                  <input class="field-input" type="text" [(ngModel)]="b.branchCode" name="branchCode{{b.id}}" placeholder="Enter branch code" />
                </div>
              </div>

              <div class="field-row">
                <div class="field">
                  <label class="field-label">Branch Type <span class="req">*</span></label>
                  <select class="field-input field-select" [(ngModel)]="b.branchType" name="branchType{{b.id}}">
                    <option value="">Select</option>
                    <option value="Head Office">Head Office</option>
                    <option value="Branch">Branch</option>
                    <option value="Warehouse">Warehouse</option>
                  </select>
                </div>
                <div class="field">
                  <label class="field-label">Branch Phone number <span class="req">*</span></label>
                  <div class="phone-wrap">
                    <span class="phone-prefix" *ngIf="selectedCountryCode">
              <img class="flag-img" [src]="'https://flagcdn.com/w20/' + selectedCountryCode + '.png'" [alt]="selectedCountryCode" />
              {{ phoneCode }}
            </span>
                    <input class="field-input phone-input" type="tel" [(ngModel)]="b.branchPhone" name="branchPhone{{b.id}}" />
                  </div>
                </div>
              </div>

              <div class="field-row">
                <div class="field">
                  <label class="field-label">Branch Email <span class="req">*</span></label>
                  <input class="field-input" type="email" [(ngModel)]="b.branchEmail" name="branchEmail{{b.id}}" placeholder="Enter email" />
                </div>
                <div class="field">
                  <label class="field-label">Manager Name <span class="req">*</span></label>
                  <input class="field-input" type="text" [(ngModel)]="b.managerName" name="branchManager{{b.id}}" placeholder="Enter manager name" />
                </div>
              </div>

              <div class="field-row">
                <div class="field">
                  <label class="field-label">Activation Status <span class="req">*</span></label>
                  <select class="field-input field-select" [(ngModel)]="b.activationStatus" name="branchStatus{{b.id}}">
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>

                <div class="field">
                  <div class="label-location-row">
                    <label class="field-label">City <span class="req">*</span></label>
                    <button type="button" class="pick-location-btn" (click)="openMapPicker(b)">
                      Pick my location
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="#009ebf">
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                      </svg>
                    </button>
                  </div>
                  <input class="field-input" type="text" [(ngModel)]="b.city" name="branchCity{{b.id}}" placeholder="City" />
                </div>
              </div>

              <div class="field-row">
                <div class="field">
                  <label class="field-label">Longitude <span class="req">*</span></label>
                  <input class="field-input" type="text" [(ngModel)]="b.longitude" name="branchLng{{b.id}}" />
                </div>
                <div class="field">
                  <label class="field-label">Latitude <span class="req">*</span></label>
                  <input class="field-input" type="text" [(ngModel)]="b.latitude" name="branchLat{{b.id}}" />
                </div>
              </div>

              <div class="field-row">
                <div class="field">
                  <label class="field-label">Radius <span class="req">*</span></label>
                  <input class="field-input" type="text" [(ngModel)]="b.radius" name="branchRadius{{b.id}}" placeholder="Enter allowed radius for company" />
                </div>
                <div class="field">
                  <label class="field-label">Currency <span class="req">*</span></label>
                  <select class="field-input field-select" [(ngModel)]="b.currency" name="branchCurrency{{b.id}}">
                    <option value="">Select</option>
                    <option value="PKR">PKR</option>
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                  </select>
                </div>
              </div>

              <div class="field">
                <label class="field-label">Branch Logo <span class="req">*</span></label>
                <label class="upload-area">
                  <img *ngIf="b.logoPreview" [src]="b.logoPreview" class="logo-preview" alt="branch logo" />
                  <ng-container *ngIf="!b.logoPreview">
                    <div class="upload-icon-box">
                      <svg width="26" height="26" viewBox="0 0 24 24" fill="white">
                        <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4c-2.89 0-5.4 1.64-6.65 4.04C2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
                      </svg>
                    </div>
                    <span class="upload-text">Upload logo</span>
                  </ng-container>

                  <input type="file" accept="image/*" style="display:none" (change)="onLogoUpload($event, b)" />
                </label>
              </div>
            </div>

            <!-- Business unit creation -->
            <button type="button" class="branch-section-btn" (click)="toggleBranchBU(b.id)">
              <span>Business unit creation</span>
              <span class="toggle-arrow" [class.rotated]="b.buExpanded">&#9660;</span>
            </button>

            <div class="branch-bu-content" *ngIf="b.buExpanded">
              <div class="add-branch-row">
                <button type="button" class="add-branch-btn" (click)="addBusinessUnit(b)">
                  <span class="plus">+</span> Add new unit
                </button>
              </div>

              <div class="coming-soon" *ngIf="!b.businessUnits.length">No units added yet.</div>

              <div class="branch-card bu-card" *ngFor="let u of b.businessUnits; let ui = index">
                <div class="branch-card-header" (click)="toggleBusinessUnit(b, u.id)">
                  <div class="branch-title">Unit number {{ ui + 1 }}</div>

                  <div class="branch-header-actions">
                    <button
                      type="button"
                      class="delete-branch-btn"
                      title="Delete unit"
                      (click)="removeBusinessUnit(b, u.id); $event.stopPropagation()"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2">
                        <path d="M3 6h18"></path>
                        <path d="M8 6V4h8v2"></path>
                        <path d="M6 6l1 14h10l1-14"></path>
                      </svg>
                    </button>

                    <span class="toggle-arrow" [class.rotated]="u.expanded">&#9660;</span>
                  </div>
                </div>

                <div *ngIf="u.expanded">
                  <div class="field-row">
                    <div class="field">
                      <label class="field-label">Unit Name <span class="req">*</span></label>
                      <input class="field-input" type="text" [(ngModel)]="u.unitName" name="unitName{{b.id}}_{{u.id}}" placeholder="Enter unit name" />
                    </div>
                    <div class="field">
                      <label class="field-label">Unit Code <span class="req">*</span></label>
                      <input class="field-input" type="text" [(ngModel)]="u.unitCode" name="unitCode{{b.id}}_{{u.id}}" placeholder="Enter unit code" />
                    </div>
                  </div>

                  <div class="field-row">
                    <div class="field">
                      <label class="field-label">Unit Type <span class="req">*</span></label>
                      <select class="field-input field-select" [(ngModel)]="u.unitType" name="unitType{{b.id}}_{{u.id}}">
                        <option value="">Select</option>
                        <option value="Sales">Sales</option>
                        <option value="Operations">Operations</option>
                        <option value="Support">Support</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="field-label">Manager name</label>
                      <input class="field-input" type="text" [(ngModel)]="u.managerName" name="unitManager{{b.id}}_{{u.id}}" placeholder="Enter manager name" />
                    </div>
                  </div>

                  <div class="field-row">
                    <div class="field">
                      <label class="field-label">Manager Email <span class="req">*</span></label>
                      <input class="field-input" type="email" [(ngModel)]="u.managerEmail" name="unitEmail{{b.id}}_{{u.id}}" placeholder="Enter email" />
                    </div>
                    <div class="field">
                      <label class="field-label">Activation Status <span class="req">*</span></label>
                      <select class="field-input field-select" [(ngModel)]="u.activationStatus" name="unitStatus{{b.id}}_{{u.id}}">
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                    </div>
                  </div>

                  <div class="field">
                    <label class="field-label">Description <span class="req">*</span></label>
                    <textarea
                      class="field-input field-textarea"
                      [(ngModel)]="u.description"
                      name="unitDesc{{b.id}}_{{u.id}}"
                      placeholder="Default business unit created with the company registration."
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div> <!-- /branch-card -->
        </div>
      </div>

      <!-- ================= SEED SAMPLE DATA ================= -->
      <div class="seed-data-box">
        <input type="checkbox" id="seedData" [(ngModel)]="seedSampleData" name="seedSampleData" class="seed-checkbox" />
        <label for="seedData" class="seed-label">
          <span class="seed-title">Seed sample data</span>
          <span class="seed-desc">Populate your account with demo orders, invoices, contacts and items to explore the ERP.</span>
        </label>
      </div>

      <!-- ================= ERROR / SUBMIT ================= -->
      <div *ngIf="errorMessage" class="form-error">{{ errorMessage }}</div>

      <p class="terms-text">
        By clicking on start now you accept our
        <a href="/subscription-agreement" target="_blank" rel="noopener" class="terms-link">Subscription Agreement</a> and
        <a href="/privacy-policy" target="_blank" rel="noopener" class="terms-link">Privacy Policy</a>
      </p>

      <button type="submit" class="start-btn" [disabled]="isLoading">
        <span *ngIf="!isLoading">Start now</span>
        <span *ngIf="isLoading" class="btn-spinner"></span>
      </button>
    </form>
  </div>

  <!-- Setup Screen -->
  <div class="setup-screen" *ngIf="showSetupScreen">
    <h2 class="setup-title">Setting Up Your ERP</h2>
    <p class="setup-subtitle">{{ seedSampleData ? 'Populating sample data across all modules...' : 'Setting up your workspace...' }}</p>

    <!-- Circular progress -->
    <div class="ring-wrapper">
      <svg class="progress-ring" viewBox="0 0 120 120">
        <circle class="ring-bg" cx="60" cy="60" r="50" />
        <circle
          class="ring-fill"
          cx="60" cy="60" r="50"
          [style.strokeDasharray]="progressCircumference"
          [style.strokeDashoffset]="progressOffset"
        />
      </svg>
      <span class="ring-percent">{{ setupProgress }}%</span>
    </div>

    <p class="seeding-label">{{ seedSampleData ? 'Seeding' : 'Configuring' }} {{ currentSetupModule }}...</p>

    <!-- Linear progress bar -->
    <div class="linear-bar">
      <div class="linear-fill" [style.width.%]="setupProgress"></div>
    </div>

    <!-- Tip -->
    <div class="setup-tip" [class.tip-fade-out]="!tipVisible">
      <svg class="tip-icon" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      {{ currentSetupTip }}
    </div>

    <!-- Module chips -->
    <div class="module-chips">
      <span
        *ngFor="let mod of setupModules; let i = index"
        class="module-chip"
        [class.chip-done]="isModuleDone(i)"
        [class.chip-active]="isModuleActive(i)"
      >
        <svg *ngIf="isModuleDone(i)" class="chip-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3,8 6.5,11.5 13,5"/>
        </svg>
        <svg *ngIf="!isModuleDone(i)" class="chip-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="8" cy="8" r="6"/><line x1="8" y1="5" x2="8" y2="8"/><line x1="8" y1="11" x2="8.01" y2="11"/>
        </svg>
        {{ mod.name }}
      </span>
    </div>
  </div>
</div>

